import { j as jsxRuntimeExports } from "./doenetml-CDvV96YD.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-YzDSBjpZ.js";
const tag = React__default.memo(function Tag(props) {
  let { id, SVs, children } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  let open = "<";
  let close = ">";
  if (SVs.selfClosed) {
    close = "/>";
  } else if (SVs.closing) {
    open = "</";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("code", { id, style: { color: "#3e844a" }, children: [
    open,
    children,
    close
  ] });
});
export {
  tag as default
};
